import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { NestingButton } from "../../../../Constant";
import { DynamicNesting } from "./DynamicNesting";
import { StaticNesting } from "./StaticNesting";
import { NESTING } from "../../../../Data/Buttons/ButtonGroup";

const Nesting = () => {
  return (
    <>
      <Col lg="6">
        <Card className="height-equal">
          <CommonCardHeader title={NestingButton} span={NESTING} />
          <CardBody className="btn-group-wrapper">
            <StaticNesting />
            <DynamicNesting />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Nesting;
